import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import CareersPage from './pages/CareersPage';
import CraigslistLandingPage from './pages/CraigslistLandingPage';
import ApplicationPage from './pages/ApplicationPage';
import SuccessPage from './pages/SuccessPage';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<CraigslistLandingPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/apply/:jobId" element={<ApplicationPage />} />
            <Route path="/apply" element={<ApplicationPage />} />
            <Route path="/success" element={<SuccessPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;